import type { SupportedBrannanHeaderPhotoLayout } from '@shared/types/WebsiteHeaderSettings.types';

// Every in-flow HeaderV2 layout (renders EventNameNav). The standalone background
// variants (photoBackground/videoBackground/*Monogram) never reach HeaderV2, but the
// explicit allowlist keeps the compatibility contract auditable and adjustable.
const COMPATIBLE_LAYOUTS: ReadonlySet<SupportedBrannanHeaderPhotoLayout> = new Set<SupportedBrannanHeaderPhotoLayout>([
  'center',
  'fullWidth',
  'pageWidth',
  'photoSlider',
  'photoSliderPageWidth',
  'photoTrio',
  'photoTrioPageWidth',
  'noPhoto',
  'monogram',
  'photoArch',
  'photoDuoLeft',
  'photoDuoRight',
  'photoMarquee',
  'photoMarqueePageWidth',
  'videoArch',
]);

export const isMastheadCompatibleLayout = (layout: Maybe<SupportedBrannanHeaderPhotoLayout>): boolean => {
  return !!layout && COMPATIBLE_LAYOUTS.has(layout);
};
